<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="app-main-content">
    <div class="tabs-container">
      <el-tabs v-model="activeTabName" type="card" style="width:100%;">
        <el-tab-pane v-if="estimateListQuery" :label="$t('CargoMsg.Cargo_EstimateListQuery')" name="estimateListQuery">
          <estimate-list-query />
        </el-tab-pane>
        <el-tab-pane v-if="billsPayable" :label="$t('CargoMsg.Cargo_BillsPayable')" name="billsPayable">
          <bills-payable-query />
        </el-tab-pane>
        <el-tab-pane v-if="mappingConfiguration" :label="$t('CargoMsg.Cargo_MappingConfiguration')" name="mappingConfiguration">
          <mapping-management />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import estimateListQuery from '@/views/cargo/v0/Clearing/components/SharedCenter/estimateListQuery'
import billsPayableQuery from '@/views/cargo/v0/Clearing/components/SharedCenter/billsPayableQuery'
import mappingManagement from '@/views/cargo/v0/Clearing/components/SharedCenter/mappingManagement'
import checkPermission from '@/utils/permission'

export default {
  name: 'SharedCenter',
  components: {
    estimateListQuery,
    billsPayableQuery,
    mappingManagement
  },
  data() {
    return {
      activeTabName: 'estimateListQuery',
      estimateListQuery: false,
      billsPayable: false,
      mappingConfiguration: false
    }
  },
  created() {
    this.estimateListQuery = checkPermission(['tab_SharedCenter_tabEstimateListQuery'])
    this.billsPayable = checkPermission(['tab_SharedCenter_tabBillsPayable'])
    this.mappingConfiguration = checkPermission(['tab_SharedCenter_tabMappingConfiguration'])
    if (this.estimateListQuery) {
      this.activeTabName = 'estimateListQuery'
    } else if (this.billsPayable) {
      this.activeTabName = 'billsPayable'
    } else if (this.mappingConfiguration) {
      this.activeTabName = 'mappingConfiguration'
    }
  },
  beforeMount() {
  },
  mounted() {
  },
  methods: {}
}
</script>

<style lang="scss">
</style>
